export type Token =
  | { type: 'term'; value: string }
  | { type: 'and' }
  | { type: 'or' }
  | { type: 'not' }
  | { type: 'lparen' }
  | { type: 'rparen' };

export type Node =
  | { type: 'term'; value: string }
  | { type: 'and'; children: Node[] }
  | { type: 'or'; children: Node[] }
  | { type: 'not'; child: Node };

export type BooleanQueryErrorCode =
  | 'unbalanced_parenthesis'
  | 'empty_group'
  | 'dangling_operator'
  | 'pure_negative';

export class BooleanQueryError extends Error {
  public readonly code: BooleanQueryErrorCode;

  constructor(code: BooleanQueryErrorCode) {
    super(code);
    this.code = code;
    this.name = 'BooleanQueryError';
    Object.setPrototypeOf(this, BooleanQueryError.prototype);
  }
}

export const term = (value: string): Node => ({ type: 'term', value });
export const and = (children: Node[]): Node => ({ type: 'and', children });
export const or = (children: Node[]): Node => ({ type: 'or', children });
export const not = (child: Node): Node => ({ type: 'not', child });
